@if (scheduledPaymentsEnabled && !scheduledControl.disabled) {
<nz-form-item>
  <nz-form-control>
    <label nz-checkbox [formControl]="scheduledControl" [nzDisabled]="editStandingOrderId" translate>payment.schedule</label>
  </nz-form-control>
</nz-form-item>
@if (scheduled) {
<nz-form-item>
  <nz-form-label translate>payment.scheduled.details.frequency</nz-form-label>
  <nz-form-control>
    <nz-select nzSize="large" [formControl]="scheduledFrequencyControl">
      @for (periodType of scheduledPaymentPeriodTypes; track periodType) {
      <nz-option [nzValue]="periodType" [nzLabel]="'payment.scheduled.period.'+ periodType | translate:locale.language"> </nz-option>
      }
    </nz-select>
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label translate>payment.scheduled.details.startDate</nz-form-label>
  <nz-form-control>
    <nz-date-picker
      nzSize="large"
      [nzShowToday]="false"
      [nzAllowClear]="false"
      [nzDisabledDate]="startDateDisabled"
      [formControl]="scheduledStartDateControl"
    ></nz-date-picker>
  </nz-form-control>
</nz-form-item>
@if (scheduledFrequency !== ScheduledPaymentPeriodType.DO_NOT_REPEAT) {
<nz-form-item>
  <nz-form-label translate>payment.scheduled.details.endDate</nz-form-label>
  <nz-form-control>
    <nz-date-picker nzSize="large" [nzShowToday]="false" [nzDisabledDate]="endDateDisabled" [formControl]="scheduledEndDateControl"></nz-date-picker>
  </nz-form-control>
</nz-form-item>
} } }
